import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import "./../../css/search-form.css";

class SearchForm extends Component {
	showLogo() {
		if (this.props.siteInfo.isLoading) {
			return <div />;
		} else if (this.props.siteInfo.site.logo) {
			return (
				<Link className="top_logo" to="/">
					<img src={this.props.siteInfo.site.logo} alt={this.props.siteInfo.site.title} />
				</Link>
			);
		} else {
			return null;
		}
	}

	render() {
		let Logo = this.showLogo();
		return <div>{Logo}</div>;
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo
	};
};

export default connect(mapStateToProps)(SearchForm);



// WEBPACK FOOTER //
// ./src/components/header/HeaderLogo.js